import React from "react";
import { ProductWriteOffInput } from "@me-team/host/main/graphql/types";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ProductTableRow from "./ProductTableRow";
import { CustomProductFromTechMapInterface, InterfaceProductWithTechMap } from "../../../../../interfaces/interfaces";

type ProductWithTechMapProps = {
    productFromTechMap: InterfaceProductWithTechMap[];
    changeProductsToWriteOff: (
        productToWriteOff: ProductWriteOffInput,
        changedField: keyof ProductWriteOffInput,
        isFromTechMap?: boolean,
        techMapId?: number
    ) => void;
    removeProductFromWriteOff: (productId: number, isProductFromTechMap: boolean, techMapId?: number) => void;
};

const ProductWithTechMap: React.FC<ProductWithTechMapProps> = (props) => {
    const { t: translate } = useTranslation();
    return (
        <>
            {props.productFromTechMap.map((techMap) => {
                if (techMap.techMapProductInfo?.length > 0) {
                    return (
                        <div key={techMap.techMapId} className="mb-5">
                            <h4 className={"fw-normal mb-4"}>{techMap.techMapName}</h4>
                            <Table responsive className="align-start">
                                <thead className="fs-7">
                                    <tr>
                                        <th className="col-2 ps-4">{translate("Product name")}</th>
                                        <th className="col-1"></th>
                                        <th className="col-3" style={{ minWidth: "150px" }}>
                                            {translate("Warehouse")}
                                        </th>
                                        <th className="col-2" style={{ minWidth: "100px" }}>
                                            {translate("Quantity")}
                                        </th>
                                        <th className="col-2" style={{ minWidth: "100px" }}>
                                            {translate("Measurement")}
                                        </th>
                                        <th className="col-1"></th>
                                        <th className="col-1"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {techMap.techMapProductInfo.map((technology: CustomProductFromTechMapInterface) => {
                                        return (
                                            <ProductTableRow
                                                key={technology.id}
                                                techMapId={techMap.techMapId}
                                                changeProductsToWriteOff={props.changeProductsToWriteOff}
                                                technology={technology}
                                                removeProductFromWriteOff={props.removeProductFromWriteOff}
                                            />
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    );
                }
            })}
        </>
    );
};

export default React.memo(ProductWithTechMap);
